import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { RoutingService, UserIdService } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import * as Constants from '../common/constants/CommonConstants';
@Injectable({
  providedIn: 'root',
})
export class HttpInterceptorService implements HttpInterceptor {
  public readonly userIdHeader = 'sap-commerce-cloud-user-id';
  public readonly uniqueUserIdConstants: Set<string> | any;
  constructor(
    public route: Router,
    public routingService: RoutingService,
    public userIdService: UserIdService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let isAsm = localStorage.getItem('asm_enabled');
    if (isAsm) {
      let userIdObservable: Observable<string | any>;
      userIdObservable = this.userIdService.takeUserId();
      return userIdObservable.pipe(
        concatMap((userId) => {
          if (
            userId &&
            userId !== Constants.ANONYMOUS_USER &&
            userId !== Constants.CURRENT_USER
          ) {
            const request = req.clone({
              headers: req.headers.set(this.userIdHeader, userId),
            });
            return next.handle(request);
          } else {
            return next.handle(req);
          }
        })
      );
    }
    return next
      .handle(req)
      .pipe(
        catchError((err) => {
          //restrict redirection on OOTB APIs that are not needed and is failing
          if (
            !window.location.href.includes('order-confirmation') &&
            !err.url.includes('logout') &&
            !err.url.includes('revoke') &&
            !err.url.includes('not-found') &&
            !err.url.includes('.json') &&
            !err.url.includes('createUpdateB2BUser') &&
            Constants.ERROR_STATUS_CODES.indexOf(err.status) > -1
          ) {
            this.redirectToGlobalExceptionPage();
          }
          return throwError(err);
        })
      )
      .pipe(
        map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
          if (evt instanceof HttpResponse) {
            if (evt.url?.includes('simulate') && evt.body.isPricingError) {
              this.redirectToGlobalExceptionPage();
            }
          }
          return evt;
        })
      );
  }

  redirectToGlobalExceptionPage() {
    this.routingService.go('/notFound');
  }
}
